import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from "react-redux";
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Avatar, Typography, Button, LinearProgress } from '@material-ui/core';

// Shared components
import { Portlet, PortletContent, PortletFooter } from 'components';

import api from '../../../../api';

// Component styles
import styles from './styles';

class AccountProfile extends Component {
  state = {
    user: null,
    loading: true,
    error: null
  };
  async componentDidMount() {
    try {
      const response = await api.getCurrentInfo();
      this.setState({ user: response.data, loading: false });
      //console.log(this.state.user);
    } catch (error) {
      console.error("Error fetching user data:", error);
      this.setState({ error: "Failed to load user info", loading: false });
    }
  }
  render() {
    const { classes, className, ...rest } = this.props;
    const { user, loading, error } = this.state;

    const rootClassName = classNames(classes.root, className);

    if (loading) {
      return <LinearProgress />;
    }

    if (error) {
      return <Typography color="error">{error}</Typography>;
    }
    return (
      <Portlet
        {...rest}
        className={rootClassName}
      >
        <PortletContent>
          <div className={classes.details}>
            <div className={classes.info}>
              <Typography variant="h2">{user?.username}</Typography>
              <Typography
                className={classes.dateText}
                variant="body1"
              >
                {user?.email}
              </Typography>
            </div>
            <Avatar
              className={classes.avatar}
              src="/images/avatars/visualon.png"
            />
          </div>
        </PortletContent>
      </Portlet>
    );
  }
}

AccountProfile.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(AccountProfile);